<template>
  <footer class="footer">
    <div class="footer__content">
      <el-row :gutter="32">
        <el-col
          :xs="24"
          :md="16"
          :lg="12"
        >
          <a-footer-address />
        </el-col>

        <el-col
          :xs="24"
          :md="8"
          :lg="12"
        >
          <a-footer-navigation />
        </el-col>
      </el-row>

      <a-footer-social />
    </div>
  </footer>
</template>

<script>
import AFooterAddress from './atoms/AFooterAddress'
import AFooterNavigation from './atoms/AFooterNavigation'
import AFooterSocial from './atoms/AFooterSocial'

export default {
  name: 'SFooter',

  components: {
    AFooterAddress,
    AFooterNavigation,
    AFooterSocial
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  margin-top: 5vw;
  padding: 2rem 0;

  font-size: 0.875em;

  background: #fff;

  &::before {
    content: "";

    position: absolute;
    height: 5vw;
    left: 0;
    right: 0;
    bottom: 100%;

    background:
      $--color-background
      url("~@/assets/footer-wave.svg") center / 100% 100% no-repeat;
  }

  @media (min-width: $--container-width) {
    margin-top: 3.25rem;

    &::before {
      height: 3.25rem;
    }
  }
}

.footer__content {
  width: $--container-width;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 $--container-padding;
}
</style>
